var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"text-center"},[_vm._v("哦哦，休息一下马上回来 "),_c('i',{staticClass:"far fa-grin-tears"})])}]

export { render, staticRenderFns }